import React from 'react';
import c from 'classnames';
import ModalHeadingText from '../ModalHeadingText';
import ModalSubText from '../ModalSubText';
import s from './ModalHeader.scss';
/**
 * The top portion of a modal. It has a heading and -- optionally -- a subheading and right-side slot.
 */
var ModalHeader = function (_a) {
    var heading = _a.heading, subheading = _a.subheading, right = _a.right, className = _a.className;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement("div", { className: s['heading-and-subheading-block'] },
            React.createElement(ModalHeadingText, null, heading),
            subheading && React.createElement(ModalSubText, null, subheading)),
        React.createElement("div", { className: s['right'] }, right)));
};
ModalHeader.displayName = 'ModalHeader';
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map